<!--Element单选树形控件-->
<template>
	<div class="el_Tree_Body" style="width:3rem">
		<transition name="el-zoom-in-center">
		<div v-show="isShow" class="elTree_body">
		<div style="display: flex;padding-top:10px;align-items: center;" class="search-input">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
		</div>
		 <div class="scroll" style="height:97%;width: 100%;" >
		 <el-scrollbar style="height:100%;width: 100%;">
			<el-tree :data="data"  :accordion="true" :default-expanded-keys="defaultExpanded" 
			:current-node-key='defaultDevice'
			 :expand-on-click-node="true" 
			node-key="id" :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
				<span class="custom-tree-node" slot-scope="{node}">
			    <!-- <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.type=='group'&&node.data.unitid!=''"/>
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='group'&&node.data.unitid==''"/>
			 	<img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'"/> -->
			 	<span style="padding: 5px;">{{node.label }}</span>
				</span>
			</el-tree>
		</el-scrollbar>
		</div>
		</div>
	 </transition>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'energyAreaVos',
					label: 'label'
				},
				isShow: true,
				defaultExpanded:[],
				defaultDevice:"",
                nowArea:[]
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
            this.nowArea = this.$store.cacheStore.state.setBuilding
            this.defaultExpanded = [this.nowArea.id]
            this.defaultDevice = this.nowArea.id
           this.$nextTick(()=>{
					//默认选中
					this.$refs['tree'].setCurrentKey(this.defaultDevice);
				})
		},
        
		destroyed() {},
		computed: {
			storeNowArea(){
                return this.$store.cacheStore.state.setBuilding
            }
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
             dataList(val){
              this.data = val
           },
           storeNowArea(v){
              this.nowArea = v
              this.defaultExpanded = [v.id]
            this.defaultDevice = v.id
            this.$nextTick(()=>{
					//默认选中
					this.$refs['tree'].setCurrentKey(this.defaultDevice);
				})
           }
			

		},
		methods: {
			
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				var d = value
				d.name = d.label
				this.$store.cacheStore.commit("setBuilding", d)
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.el_Tree_Body .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        width: 3rem;
		background-color:#bed5ef;
	}
    
	.el-scrollbar .el-scrollbar__wrap {
	overflow-x: hidden;
	}
	.el-scrollbar__wrap .el-scrollbar__view {
	white-space: nowrap;
	display: inline-block;
	}
    .elTree_body {
         width: 3rem !important;
         margin-top: 10px;
         height: 100% !important;
    }
	
	
</style>